import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  apiPrefix,
  CasdoorService,
  httpMethodType,
} from "./Casdoor.service";
import { getServerURL, getAppApiURL } from "../utils/serverUrl";

const premiseURL = getServerURL();
const appApiURL = getAppApiURL();

dayjs.extend(utc);
dayjs.extend(timezone);

class UserService extends CasdoorService {
  constructor() {
    super();
    this.basedUrl = `${premiseURL}/${apiPrefix}`;
  }

  async logoutUser(token, param = {}) {
    const apiName = 'logout';
    const url = `${this.basedUrl}/${apiName}`;
    const formParam = new URLSearchParams({
      id_token_hint: param.id_token_hint || token,
      post_logout_redirect_uri:
        param.post_logout_redirect_uri || `${appApiURL}/login`,
      state: param.state || `${Date.now()}`,
    });
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async getCaptcha(appId, provider) {
    const apiName = 'get-capcha';
    const url = `${this.basedUrl}/${apiName}?applicationId=${appId}&isCurrentProvider=${provider}`;
    const config = {
      method: httpMethodType.get,
      // params: param
    };
    return super.sendRequest(url, config);
  }

  async getUserSetting(orgId, userName) {
    const apiName = 'get-user';
    const url = `${this.basedUrl}/${apiName}?id=${orgId}/${userName}`;
    const token = localStorage.getItem('token');
    const config = {
      method: httpMethodType.get,
      ...(token && {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }),
      // params: param
    };
    return super.sendRequest(url, config);
  }

  async updateUserSetting(orgId, userName, param, token) {
    const apiName = 'update-user';
    const url = `${this.basedUrl}/${apiName}?id=${orgId}/${userName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param)
    };
    return super.sendRequest(url, config);
  }

  async deleteUserAccount(param, token) {
    const apiName = 'delete-user';
    const url = `${this.basedUrl}/${apiName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param)
    };
    return super.sendRequest(url, config);
  }

  async checkUserPassword(param, token) {
    const apiName = 'check-user-password';
    const url = `${this.basedUrl}/${apiName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param),
    };
    return super.sendRequest(url, config);
  }

  async updateUserPassword(param, token) {
    const apiName = 'set-password';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async initMfaSetting(param, token) {
    const apiName = 'mfa/setup/initiate';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async verifyMfaSetting(param, token) {
    const apiName = 'mfa/setup/verify';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async enableMfaSetting(param, token) {
    const apiName = 'mfa/setup/enable';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async deleteMfaSetting(param, token) {
    const apiName = 'delete-mfa';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async preferMfaSetting(param, token) {
    const apiName = 'set-preferred-mfa';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async sendVerifyMail(param, token) {
    const apiName = 'send-verification-code';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

}

export default new UserService();
